export {
  pluralize,
  formatCount,
  GOODS_FORMS,
  THINGS_FORMS,
  BONUS_FORMS,
  DAYS_FORMS,
  type PluralForms,
} from './plural';
